import sanityClient from '@sanity/client';

const client = sanityClient({
  projectId: process.env.REACT_APP_PORJECTID,
  dataset: 'production',
  apiVersion: 'v2021-06-07', // use current UTC date - see "specifying API version"!
  //   token: 'sanity-auth-token', // or leave blank for unauthenticated usage
  useCdn: true, // `false` if you want to ensure fresh data
});

//2021-03-25

export default client;
